import { render, staticRenderFns } from "./NaturePage.vue?vue&type=template&id=06c289b2&scoped=true&"
import script from "./NaturePage.vue?vue&type=script&lang=js&"
export * from "./NaturePage.vue?vue&type=script&lang=js&"
import style0 from "./NaturePage.vue?vue&type=style&index=0&id=06c289b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c289b2",
  null
  
)

export default component.exports